import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    onClick;
    disabled = false;
    loading = false;
    async onButtonClick() {
        this.disabled = true;
        this.loading = true;
        try {
            await this.onClick();
        }
        finally {
            this.disabled = false;
            this.loading = false;
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "onClick", void 0);
default_1 = __decorate([
    Component({
        name: 'loading-button',
        components: {},
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
